import React from 'react'
import styled from 'styled-components'
import { gradientBackgroundText } from 'styles/gradients'
import BackgroundImage from 'components/BackgroudImage'
import mediaQuery from 'styles/mediaQuery'
import { containerDefaultStyles } from 'styles/defaults'
import { FEATURES } from './constants'
import { universalLink } from '../../../constants/mobile-app'
import { ButtonGradient } from '../../Button'
import { trackGetApp } from 'tracking/pixel'

const Section = styled.section`
  padding: 60px 0;

  ${mediaQuery.mobile} {
    padding-bottom: 10px;
  }
`

const Container = styled.div`
  ${containerDefaultStyles};
`

const Title = styled.h3`
  font-size: 57px;
  line-height: 1.2;
  ${gradientBackgroundText};
  text-align: center;
  margin-bottom: 100px;

  ${mediaQuery.mobile} {
    font-size: 28px;
    line-height: 38px;
    width: 300px;
    max-width: 100%;
    margin: 0 auto 20px;
  }
`

const Row = styled.div`
  width: 100%;

  ${mediaQuery.tabletMin} {
    display: flex;
    flex-wrap: wrap;
  }

  & > * {
    min-width: 0;
  }
`

const Column = styled.div`
  flex: 0 0 33.333%;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 0 15px;
  margin-bottom: 60px;

  ${mediaQuery.bigTablet} {
    flex: 0 0 50%;
  }
  ${mediaQuery.tablet} {
    flex: 0 0 50%;
  }
  ${mediaQuery.mobile} {
    width: 300px;
    max-width: 100%;
    margin: 0 auto 20px;
  }
`

const ImageStyled = styled(BackgroundImage)`
  height: 520px;
  width: ${({ width }) => (width ? width : 260)}px;
  background-size: 100% auto;
  background-repeat: no-repeat;
  background-position: center;
`

const ItemTitle = styled.h6`
  font-size: 26px;
  line-height: 34px;
  letter-spacing: 0.03em;
  margin-bottom: 20px;
  ${gradientBackgroundText};
  width: 350px;
  max-width: 100%;

  ${mediaQuery.desktopMin} {
    margin-top: 20px;
  }
  ${mediaQuery.tablet} {
    font-size: 20px;
    line-height: 28px;
  }
  ${mediaQuery.mobile} {
    font-size: 20px;
    line-height: 28px;
  }
`

const ItemDescription = styled.p`
  font-size: 18px;
  line-height: 30px;
  font-weight: 400;

  ${mediaQuery.tablet} {
    font-size: 18px;
    line-height: 22px;
  }
  ${mediaQuery.mobile} {
    font-size: 18px;
    line-height: 22px;
  }
`

const Button = styled(ButtonGradient)`
  position: relative;
  height: 70px;
  border-radius: 35px;
  width: 380px;
  max-width: 100%;
  margin: 40px auto 0;

  ${mediaQuery.tabletMax} {
    height: 50px;
    border-radius: 25px;
    width: 260px;
    max-width: 100%;
    margin: 0 auto 40px;
  }

  & > span {
    font-size: 18px;
    line-height: 30px;
    font-weight: bold;
    display: block;
  }

  &:after {
    border-radius: 35px;
  }
`

const ReadAboutUs = () => (
  <Section>
    <Container>
      <Title>What is Flip?</Title>
      <Row>
        {FEATURES.map(({ title, description, image, imageWidth }) => (
          <Column key={title}>
            <ImageStyled fileName={image} width={imageWidth} />
            <ItemTitle dangerouslySetInnerHTML={{ __html: title }} />
            <ItemDescription>{description}</ItemDescription>
          </Column>
        ))}
      </Row>
      <Button as="a" href={universalLink} tabletMax onClick={trackGetApp}>
        <span>TRY FLIP NOW</span>
      </Button>
    </Container>
  </Section>
)

export default ReadAboutUs
